module.exports = __webpack_public_path__ + "static/media/esg-imp-demo.52c0e7e3.pdf";